/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBarStacked: {
  name: 'bar-stacked';
  data: string;
} = {
  name: 'bar-stacked',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 .5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0V1a.5.5 0 0 1 .5-.5Zm-7 5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm0 5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 1 .5-.5Zm-6.5 2a.5.5 0 0 0-1 0V15a.5.5 0 0 0 1 0v-2.5Zm13.5 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2a.5.5 0 0 1 .5-.5Zm.5-6.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0V6ZM1 11a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
